// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"3e958bd1","615":"0c7dfa75"}[chunkId] + ".chunk.css";
};